import { combineReducers } from '@reduxjs/toolkit';
import * as ActiveLessons from './activeLessons';
import * as CompletedLessons from './completedLessons';

const reducer = combineReducers({
  activeLessons: ActiveLessons.reducer,
  completedLessons: CompletedLessons.reducer
});

export { reducer, ActiveLessons, CompletedLessons };
export * from './selectors';
export * from './types';
